/**
 * Project periods, rendered in the reader's language.
 *
 * Projects carry structured `start` and `end` — "YYYY-MM", "YYYY", or the
 * literal "present" — rather than a written-out string, so that the same
 * seventeen records read correctly in thirteen languages without anyone
 * hand-translating a date, and so sorting never depends on parsing prose.
 */

const parse = (value) => {
  if (typeof value !== 'string') return null;
  if (value === 'present') return { present: true };

  const match = /^(\d{4})(?:-(\d{2}))?$/.exec(value);
  if (!match) return null;

  const year = Number(match[1]);
  const month = match[2] ? Number(match[2]) - 1 : null;
  return { year, month };
};

const monthName = (locale, year, month) =>
  new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' })
    .format(new Date(Date.UTC(year, month, 1)));

const one = (locale, part) =>
  part.month === null
    ? new Intl.NumberFormat(locale, { useGrouping: false }).format(part.year)
    : monthName(locale, part.year, part.month);

export function formatPeriod(project = {}, locale = 'en', t = (key) => key) {
  const start = parse(project.start);
  const end = parse(project.end);
  if (!start) return '';

  const from = one(locale, start);

  if (end?.present) return `${from} – ${t('projects.present')}`;
  if (!end) return from;

  const to = one(locale, end);
  return from === to ? from : `${from} – ${to}`;
}

/** Just the year the work wrapped up — the hero index shows nothing else. */
export function endYear(project = {}) {
  const end = parse(project.end);
  if (!end) return '';
  if (end.present) return String(new Date().getFullYear());
  return String(end.year);
}
